export function init(callback) {
	let view;
	const buttons = Array.from(document.querySelectorAll('.js-view-switcher'));

	buttons.forEach(element => element.addEventListener('click', event => {
		view = event.currentTarget.value;
		const elements = Array.from(document.querySelectorAll('[data-view]'));

		elements.forEach(elem => elem.dataset.view = view);
		buttons.forEach(elem => elem.classList.toggle('is-selected', elem.value === view));

		if (typeof callback === 'function') {
			callback(view);
		}
	}));
}
